import "@hotwired/turbo-rails"
import "./islands"
import "./navbar"
import "./page_actions"

import { installPasskeyHandlers } from "./auth/passkey"
installPasskeyHandlers()

import { Turbo } from "@hotwired/turbo-rails"
Turbo.config.forms.confirm = (message) => confirm(message)

import { installPushHandlers } from "./push"

installPushHandlers()

import "./cable"

import "./rich_text_editor"
